/// <reference path="../../BaseNew/GAdmHromadnaOperaceBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class HromadnaOperaceAdmTrasaProTypDokumentu extends GContentBase {
        private hromadnaOperaceObj: HromadnaOperaceAdmTrasaProTypDokumentuObj & GContent;
        private data: Gordic.AdmIsl.Interface.GAdmTrasaProTypDokumentuReadDto[];
        private keys: string[];

        onContentReady() {
            this.hromadnaOperaceObj = $.extend(this as GContent, new HromadnaOperaceAdmTrasaProTypDokumentuObj())
            this.hromadnaOperaceObj.createBase({
                title: "jres:33000834",
                data: this.data,
                objectFields: ['ixs_tra_txt'],
                serviceCnt: "Gordic.Adm.WebControls.HromadnaOperaceAdmTrasaProTypDokumentu",
                keys: this.keys,
                contentId: "hromadnaOperaceAdmTrasaProTypDokumentu "
            })
        }
    }

    export class HromadnaOperaceAdmTrasaProTypDokumentuObj extends GAdmHromadnaOperaceBase<Gordic.AdmIsl.Interface.GAdmTrasaProTypDokumentuReadDto> {

        createForm(cnt: GContent<IGContentBase, any>, contentDiv: JQuery<HTMLElement>, change: OGWizardChange) {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000835").addField("gselectbox", Gordic.Prefabs.Select.wflstra(), { //RC 33000835 : Trasa dokumentu
                    name: "ixs_tra",
                    model: "model.ixs_tra=value.ixs_tra;model.ixs_tra_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    initialValue: this.options.data.map((value) => ({ ixs_tra: value.ixs_tra })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    serverFilters: {
                        aktivita: [100, 300, 500, 600, 900]
                    }
                }).addRow("jres:33000836").addField("gselectbox", Gordic.Prefabs.Select.sslstyp(), { //RC 33000836 : Typy dokumentů
                    name: "ixs_typ",
                    model: "model.ixs_typ=value.ixs_typ;model.ixs_typ_txt<=value.nazev",
                    dropdown: false,
                    multi: true,
                    itemWidth: "",
                    //initialValue: this.options.data.map((value) => ({ ixs_typ: value.ixs_typ })),
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    serverFilters: {
                        aktivita: [100, 300, 500, 600, 900]
                    }
                }).addRow("jres:29930689").addField("gstringbox", {
                    name: "poznamka",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                }).addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    model: "model.aktivita=value.aktivita;model.aktivita_txt<=value.aktivita_txt",
                    initialValue: { aktivita: 100 },
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                })
            $("<div>").appendTo(contentDiv).gform("createFrom", form);
        }

        createDefineGridData(formData: any): any {
            var cartesianResult = this.createCartesianProduct2D(this.transformDataToArrayObject(formData, ["ixs_tra", "ixs_tra_txt"]), this.transformDataToArrayObject(formData, ["ixs_typ", "ixs_typ_txt"]));
            var resultArray: any = [];
            cartesianResult.forEach((item) => {
                var data = {
                    ixs_tra: item[0]["ixs_tra"],
                    ixs_tra_txt: item[0]["ixs_tra_txt"],
                    ixs_typ: item[1]["ixs_typ"],
                    ixs_typ_txt: item[1]["ixs_typ_txt"],
                    poznamka: formData['poznamka'],
                    aktivita: formData['aktivita'],
                    aktivita_txt: formData['aktivita_txt']
                }
                resultArray.push(data);
            })
            return resultArray;
        }

        createGridFormat(gridFormat: Gordic.Data.GridFormat): Gordic.Data.GridFormat {
            gridFormat.addTextColumn({
                caption: "jres:33000798",
                name: "ixs_tra_txt",
            }).addTextColumn({
                caption: "jres:33000817",
                name: "ixs_typ_txt",
            }).addTextColumn({
                caption: "jres:29930689",
                name: "poznamka",
                editor: {
                    widget: "gstringbox",
                    options: {
                        model: "model.poznamka=value"
                    }
                }
            }).addTextColumn({
                caption: "jres:29929221",
                name: "aktivita_txt",
                editor: {
                    widget: "gselectbox",
                    options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                        dropdown: true,
                        model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                        validators: [
                            new Gordic.Validators.Required({ stopping: true })
                        ]
                    })
                }
            })
            return gridFormat;
        }

        // Volání zatím přes CSharp (přes ISL zatím nevím jak na hromadné operace)
        saveData(data: any[]): JQueryPromise<any> {
            var saveData: Gordic.AdmIsl.Interface.GAdmTrasaProTypDokumentuSaveDto[] = [];
            data.forEach((item) => {
                saveData.push({
                    ixs_tra: item['ixs_tra'],
                    ixs_typ: item['ixs_typ'],
                    poznamka: item['poznamka'],
                    aktivita: item['aktivita'],
                    NewRecord: true
                })
            })
            return this.getServiceCnt().call("SaveHromadne", { saveData: saveData }).done((results) => {
                this.createResultData(results)
            })
        }

        validateRows(data: any): Gordic.Validators.GridError[] {
            return [];
        }

        testExistMethod(data: any[]): JQueryPromise<any> {
            return $.Deferred()
        }
    }
}